import { dateFns } from '@lhb/func';
import { checkSchedule } from '@views/schedule/api/index';
import * as dayjs from 'dayjs';
/** 获取指定月份天数 */
// function getMonthDays(date: string | number) {
//   const newDate = !date ? new Date() : new Date(date);
//   const year = newDate.getFullYear();
//   const month = newDate.getMonth();
//   return new Date(year, month + 1, 0).getDate();
// }
/** 获取指定日期年、月、日 */
function getDateYearMonthDay(date) {
    var newDate = !date ? new Date() : new Date(date);
    var year = newDate.getFullYear();
    var month = newDate.getMonth() + 1;
    var day = newDate.getDate();
    return { year: year, month: month, day: day };
}
function mathRoundTwoDecimal(mo, de) {
    return Math.round((mo / de) * 10000) / 100 + '%';
}
/** 两个日期平均天数计算函数（当前年） */
function calcAverageDays(start, startObj, end, endObj) {
    var differMonths = dayjs(endObj.year + "-" + endObj.month + "-" + endObj.day).diff(dayjs(startObj.year + "-" + startObj.month + "-" + startObj.day), 'month');
    if (differMonths === 0)
        return dayjs(start).daysInMonth();
    var sumDays = 0;
    for (var i = 0; i < differMonths; i++) {
        sumDays += dayjs(endObj.year + "-" + endObj.month + "-" + endObj.day).add(i, 'month').daysInMonth();
    }
    return Math.round((sumDays / (differMonths)) * 100) / 100;
}
// 档期冲突判断函数
function judgeTimeConflict(startStamp, endStamp, start, end) {
    if ((startStamp >= start && startStamp <= end) ||
        (endStamp >= start && endStamp <= end) ||
        (startStamp <= start && endStamp >= end)) {
        return true;
    }
    return false;
}
/** 判断其他线索是否可渲染 */
function judgeOtherClueRender(dates, startStamp, endStamp, extraDates) {
    var renderLine = 1;
    if (!dates.length && !extraDates.length)
        return renderLine;
    var count = 0; // 记录并排线索冲突数量
    var prevLine = 0; // 记录并排线索渲染在第几行
    for (var i = 0; i < extraDates.length; i++) {
        var _a = extraDates[i], start = _a.start, end = _a.end, line = _a.line;
        if (judgeTimeConflict(startStamp, endStamp, start, end)) {
            count++;
            prevLine = line;
        }
        if (count >= 2)
            return false;
    }
    renderLine = prevLine === 1 ? 2 : 1; // 与已渲染线索错行渲染
    for (var i = 0; i < dates.length; i++) {
        var _b = dates[i], start = _b.start, end = _b.end;
        if (i === 0 && endStamp < start)
            return renderLine;
        if (judgeTimeConflict(startStamp, endStamp, start, end))
            return false;
    }
    // 不存在交集则渲染
    return renderLine;
}
/** 计算线索left 从第0天开始算偏移量 */
function calcClueLeft(date, day) {
    var days = dateFns.getMonthDays(date);
    return mathRoundTwoDecimal(day, days);
}
/** 计算线索width */
function calcClueWidth(start, startYearMonth, end, endYearMonth) {
    var between = Number(dateFns.diffDayBetween(start, end));
    var average = calcAverageDays(start, startYearMonth, end, endYearMonth);
    // 如果出现跨月订单需要将间隔的边框像素算上
    var width = mathRoundTwoDecimal(between, average);
    if (startYearMonth.month !== endYearMonth.month) {
        return "calc(" + width + " + " + (endYearMonth.month - startYearMonth.month) + "px)";
    }
    return width;
}
/** 计算月份线索width */
function calcMonthClueWidth(start, startYearMonth, end, endYearMonth) {
    var between = Number(dateFns.diffDayBetween(start, end));
    var average = calcAverageDays(start, startYearMonth, end, endYearMonth);
    console.log("between, average = ", between, average, endYearMonth);
    // 如果出现跨月订单需要将间隔的边框像素算上
    var width = mathRoundTwoDecimal(between, average);
    if (startYearMonth.month !== endYearMonth.month) {
        return "calc(" + width + " + " + (endYearMonth.month - startYearMonth.month) + "px)";
    }
    return width;
}
/** 生成hover单元格月份数据 */
function generateHoverMonth(monthData, clue, type) {
    if (type === void 0) { type = ''; }
    var startMonth = dayjs(clue.renderStartAt || clue.startAt).format(type === 'month' ? 'YYYY-M' : 'M');
    var differMonths = +dayjs("" + (clue.renderEndAt || clue.endAt)).diff(dayjs("" + (clue.renderStartAt || clue.startAt)), 'month');
    if (!monthData[startMonth]) {
        monthData[startMonth] = [];
    }
    if (differMonths === 0) {
        monthData[startMonth].push(clue);
    }
    else {
        for (var i = 0; i <= differMonths; i++) {
            var currentMonth = dayjs("" + (clue.renderStartAt || clue.startAt)).add(i, 'month').format(type === 'month' ? 'YYYY-M' : 'M');
            if (!monthData[currentMonth]) {
                monthData[currentMonth] = [];
            }
            monthData[currentMonth].push(clue);
        }
    }
    return monthData;
}
/** 生成hover单元格天数据 */
function generateHoverDay(dayData, clue) {
    var startAt = clue.renderStartAt || clue.startAt;
    var endAt = clue.renderEndAt || clue.endAt;
    var between = Number(dateFns.diffDayBetween(startAt, endAt));
    var ss = new Date(startAt).getTime();
    for (var i = 0; i < between; i++) {
        var convertDate = dateFns.changeTime(ss, '-', true);
        if (!dayData[convertDate]) {
            dayData[convertDate] = [];
        }
        dayData[convertDate].push(clue);
        ss += 86400000;
    }
    return dayData;
}
/** 渲染年时间处理 */
function renderYearDateHandle(clue, year) {
    var startAt = clue.startAt;
    var endAt = clue.endAt;
    var startYearMonth = getDateYearMonthDay(startAt);
    var endYearMonth = getDateYearMonthDay(endAt);
    if (startYearMonth.year < Number(year)) {
        startAt = year + "-01-01";
        clue.renderStartAt = startAt;
        startYearMonth = getDateYearMonthDay(startAt);
    }
    if (endYearMonth.year > Number(year)) {
        endAt = year + "-12-31";
        clue.renderEndAt = endAt;
        endYearMonth = getDateYearMonthDay(endAt);
    }
    return { startAt: startAt, endAt: endAt, startYearMonth: startYearMonth, endYearMonth: endYearMonth };
}
/** 渲染月时间处理 */
function renderMonthDateHandle(clue, minDate, maxDate) {
    var startAt = clue.startAt;
    var endAt = clue.endAt;
    var startYearMonth2 = dayjs(minDate).format('YYYY-MM-01');
    var endYearMonth2 = dayjs(maxDate).endOf('month').format('YYYY-MM-DD');
    console.log("startYearMonth2 = ", startYearMonth2);
    console.log("endYearMonth2 = ", endYearMonth2);
    var startYearMonth = getDateYearMonthDay(startAt);
    var endYearMonth = getDateYearMonthDay(endAt);
    // console.log(`dayjs(startAt) < dayjs(startYearMonth) = `, dayjs(startAt), dayjs(startYearMonth), dayjs(startAt) < dayjs(startYearMonth));
    // if (dayjs(dayjs(startAt).format('YYYY-MM-01')) < dayjs(startYearMonth)) {
    //   startAt = startYearMonth;
    //   clue.renderStartAt = startAt;
    //   startYearMonth = getDateYearMonthDay(startAt);
    // }
    // if (dayjs(endAt) > dayjs(startYearMonth)) {
    //   endAt = endYearMonth;
    //   clue.renderEndAt = endAt;
    //   endYearMonth = getDateYearMonthDay(endAt);
    // }
    console.log("startAt, endAt, startYearMonth, endYearMonth = ", startAt, endAt, startYearMonth, endYearMonth);
    return { startAt: startAt, endAt: endAt, startYearMonth: startYearMonth, endYearMonth: endYearMonth };
}
/** 渲染天时间处理 */
function renderDayDateHandle(clue, minDate, maxDate) {
    var startAt = clue.startAt;
    var endAt = clue.endAt;
    var minStamp = new Date(minDate).getTime();
    var maxStamp = new Date(maxDate).getTime();
    var startStamp = new Date(startAt).getTime();
    var endStamp = new Date(endAt).getTime();
    if (startStamp < minStamp) {
        startAt = minDate;
        clue.renderStartAt = minDate;
    }
    if (endStamp > maxStamp) {
        endAt = maxDate;
        clue.renderEndAt = endAt;
    }
    return { startAt: startAt, endAt: endAt };
}
/** 年基础渲染标签 */
function basicYearRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth, renderLine) {
    clue.isRender = startYearMonth.month;
    clue.left = calcClueLeft(startAt, startYearMonth.day - 1);
    clue.width = calcClueWidth(startAt, startYearMonth, endAt, endYearMonth);
    clue.top = renderLine === 2 ? '28px' : '4px';
}
/** 月基础渲染标签 */
function basicYearMonthRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth, renderLine) {
    clue.isRender = startYearMonth.year + '-' + startYearMonth.month;
    clue.left = calcClueLeft(startAt, startYearMonth.day - 1);
    clue.width = calcMonthClueWidth(startAt, startYearMonth, endAt, endYearMonth);
    console.log("clue.width = ", clue.width);
    clue.top = renderLine === 2 ? '28px' : '4px';
}
/** 天基础渲染标签 */
function basicDayRenderTag(obj) {
    var clue = obj.clue, startAt = obj.startAt, endAt = obj.endAt, renderLine = obj.renderLine;
    clue.isRender = startAt;
    var between = Number(dateFns.diffDayBetween(startAt, endAt));
    var width = between * 100 + '%';
    clue.width = between > 1 ? "calc(" + width + " + " + (between - 1) + "px)" : width;
    clue.top = renderLine === 2 ? '28px' : '4px';
}
// 改造展位档期数据，新增是否显示、hover、月份等标签
export function refactorCalendars(obj) {
    var records = obj.records, type = obj.type, year = obj.year, minDate = obj.minDate, maxDate = obj.maxDate, _a = obj.shopName, shopName = _a === void 0 ? '' : _a;
    var manyShopData = [];
    var prevShopName = shopName;
    var newCalendars = records === null || records === void 0 ? void 0 : records.map(function (item, index) {
        var flag = 0;
        var successRenderDates = [];
        var extraRenderDates = [];
        var monthHoverData = {};
        var dayHoverData = {};
        var renderDayTag = []; // 天视图中需要渲染省略号标记的日子
        // const renderMonthTag: any = []; // 年视图中需要渲染省略号标记的月份
        if (prevShopName !== item.shopName) {
            var length = manyShopData.length;
            manyShopData.push({ name: item.shopName, index: index + length });
            prevShopName = item.shopName;
        }
        if (type === 'year') {
            item.successClues && item.successClues.forEach(function (clue, index) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderYearDateHandle(clue, year), startAt = _a.startAt, endAt = _a.endAt, startYearMonth = _a.startYearMonth, endYearMonth = _a.endYearMonth;
                generateHoverMonth(monthHoverData, clue);
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                if (index === 0) {
                    basicYearRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth);
                    successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                }
                else {
                    var prevEndDate = new Date(item.successClues[flag].endAt).getTime();
                    if (currentStartDate > prevEndDate) {
                        basicYearRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth);
                        flag = index;
                        successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                    }
                }
            });
            item.otherClues && item.otherClues.forEach(function (clue) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderYearDateHandle(clue, year), startAt = _a.startAt, endAt = _a.endAt, startYearMonth = _a.startYearMonth, endYearMonth = _a.endYearMonth;
                generateHoverMonth(monthHoverData, clue);
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                var renderLine = judgeOtherClueRender(successRenderDates, currentStartDate, currentEndDate, extraRenderDates);
                if (renderLine) {
                    basicYearRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth, renderLine);
                    extraRenderDates.push({ start: currentStartDate, end: currentEndDate, line: renderLine });
                }
            });
            item.monthHoverData = monthHoverData;
        }
        else if (type === 'month') {
            item.successClues && item.successClues.forEach(function (clue, index) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderMonthDateHandle(clue, minDate, maxDate), startAt = _a.startAt, endAt = _a.endAt, startYearMonth = _a.startYearMonth, endYearMonth = _a.endYearMonth;
                generateHoverMonth(monthHoverData, clue, 'month');
                console.log("monthHoverData = ", monthHoverData);
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                if (index === 0) {
                    basicYearMonthRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth);
                    successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                }
                else {
                    var prevEndDate = new Date(item.successClues[flag].endAt).getTime();
                    if (currentStartDate > prevEndDate) {
                        basicYearMonthRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth);
                        flag = index;
                        successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                    }
                }
            });
            item.otherClues && item.otherClues.forEach(function (clue) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderMonthDateHandle(clue, minDate, maxDate), startAt = _a.startAt, endAt = _a.endAt, startYearMonth = _a.startYearMonth, endYearMonth = _a.endYearMonth;
                generateHoverMonth(monthHoverData, clue, 'month');
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                var renderLine = judgeOtherClueRender(successRenderDates, currentStartDate, currentEndDate, extraRenderDates);
                if (renderLine) {
                    basicYearMonthRenderTag(clue, startAt, startYearMonth, endAt, endYearMonth, renderLine);
                    extraRenderDates.push({ start: currentStartDate, end: currentEndDate, line: renderLine });
                }
            });
            item.monthHoverData = monthHoverData;
        }
        else {
            item.successClues && item.successClues.forEach(function (clue, index) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderDayDateHandle(clue, minDate, maxDate), startAt = _a.startAt, endAt = _a.endAt;
                generateHoverDay(dayHoverData, clue);
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                if (index === 0) {
                    basicDayRenderTag({ clue: clue, startAt: startAt, endAt: endAt });
                    successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                }
                else {
                    var prevEndDate = new Date(item.successClues[flag].endAt).getTime();
                    if (currentStartDate > prevEndDate) {
                        basicDayRenderTag({ clue: clue, startAt: startAt, endAt: endAt });
                        flag = index;
                        successRenderDates.push({ start: currentStartDate, end: currentEndDate });
                    }
                    else {
                        var between = Number(dateFns.diffDayBetween(item.successClues[flag].endAt, clue.endAt) - 1);
                        if (between) {
                            var startDay = prevEndDate;
                            for (var i = 0; i < between; i++) {
                                startDay += 86400000; // 累加一天
                                renderDayTag.push(dateFns.changeTime(startDay, '-', true));
                            }
                        }
                    }
                }
            });
            item.otherClues && item.otherClues.forEach(function (clue) {
                // 打上是否需要渲染、left、width等渲染标记
                var _a = renderDayDateHandle(clue, minDate, maxDate), startAt = _a.startAt, endAt = _a.endAt;
                generateHoverDay(dayHoverData, clue);
                var currentStartDate = new Date(startAt).getTime();
                var currentEndDate = new Date(endAt).getTime();
                var renderLine = judgeOtherClueRender(successRenderDates, currentStartDate, currentEndDate, extraRenderDates);
                if (renderLine) {
                    basicDayRenderTag({ clue: clue, startAt: startAt, endAt: endAt, renderLine: renderLine });
                    extraRenderDates.push({ start: currentStartDate, end: currentEndDate, line: renderLine });
                    // 若出现重复渲染内容移除
                    var spliceIndex = renderDayTag.indexOf(startAt);
                    if (spliceIndex > -1) {
                        var spliceEnd = dateFns.diffDayBetween(startAt, endAt);
                        renderDayTag.splice(spliceIndex, spliceEnd);
                    }
                }
                else {
                    // 先找到已渲染的其他线索，获取最长结束时间
                    var maxLongEndDate_1 = 0;
                    if (extraRenderDates.length) {
                        extraRenderDates.forEach(function (item) {
                            var endStamp = new Date(item.end).getTime();
                            if (!maxLongEndDate_1) {
                                maxLongEndDate_1 = endStamp;
                                return;
                            }
                            if (maxLongEndDate_1 < endStamp) {
                                maxLongEndDate_1 = endStamp;
                                return;
                            }
                        });
                    }
                    var currentStamp = new Date(startAt).getTime();
                    maxLongEndDate_1 = !maxLongEndDate_1 || maxLongEndDate_1 <= currentStamp ? currentStamp : maxLongEndDate_1;
                    var between = Number(dateFns.diffDayBetween(maxLongEndDate_1, endAt));
                    if (between) {
                        var startDay = maxLongEndDate_1;
                        for (var i = 0; i < between; i++) {
                            var flag_1 = true;
                            for (var j = 0; j < successRenderDates.length; j++) {
                                var ss = new Date(successRenderDates[j].start).getTime();
                                var es = new Date(successRenderDates[j].end).getTime();
                                if (startDay >= ss && startDay <= es) {
                                    flag_1 = false;
                                    break;
                                }
                            }
                            if (flag_1) {
                                renderDayTag.push(dateFns.changeTime(startDay, '-', true));
                            }
                            startDay += 86400000; // 累加一天
                        }
                    }
                }
            });
            item.dayHoverData = dayHoverData;
            item.renderDayTag = renderDayTag;
        }
        return item;
    });
    for (var i = 0; i < manyShopData.length; i++) {
        newCalendars.splice(manyShopData[i].index, 0, manyShopData[i]);
    }
    console.log("newCalendars = ", newCalendars);
    return {
        data: newCalendars,
        shopName: prevShopName,
    };
}
export function getPopoverOffset(e, offsetTop, offsetLeft) {
    if (offsetTop === void 0) { offsetTop = 0; }
    if (offsetLeft === void 0) { offsetLeft = 0; }
    var clientX = e.clientX, clientY = e.clientY, offsetX = e.offsetX, offsetY = e.offsetY;
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var offset = {
        x: 0,
        y: 0,
    };
    // 287 添加线索弹框高度
    if (clientY + 287 > windowHeight) {
        offset.y = clientY - offsetTop - offsetY - 287;
    }
    else {
        offset.y = clientY + 60 - offsetTop - offsetY;
    }
    if (clientX + 270 > windowWidth) {
        var moreOffset = clientX + 270 - windowWidth;
        offset.x = clientX - offsetLeft - offsetX - moreOffset;
    }
    else {
        offset.x = clientX - offsetLeft - offsetX;
    }
    return offset;
}
export function collectDatesByStartAndEnd(start, end) {
    var dates = [];
    var curDate = new Date(start);
    var endDate = new Date(end);
    while (curDate <= endDate) {
        dates.push(dateFns.changeTime(curDate, '-', true));
        curDate = new Date(curDate.setDate(curDate.getDate() + 1));
    }
    return dates;
}
export function beforeSubmit(selected, callBack, failCallBack) {
    var boothInfo = selected.boothInfo, dates = selected.dates;
    var startDate = dates[0];
    var endDate = dates[dates.length - 1];
    var params = {
        boothId: boothInfo.id,
        startDate: startDate,
        endDate: endDate,
    };
    checkSchedule(params).then(function (res) {
        if (res) {
            callBack && callBack();
        }
        else {
            failCallBack && failCallBack();
        }
    });
}
export function refactorSingleClueHandle(item, currentRecord) {
    // const currentRecord = deepCopy(this.calendars[index]);
    if (item.status === 'SUCCESS') {
        var successClue = currentRecord.successClues;
        if (!successClue.length) {
            successClue.push(item);
        }
        else {
            var flag = true;
            for (var i = 0; i < successClue.length; i++) {
                if (successClue[i].clueId === item.clueId) {
                    successClue.splice(i, 1, item);
                    flag = false;
                    break;
                }
                var ss = new Date(successClue[i].startAt).getTime();
                var is = new Date(item.startAt).getTime();
                if (is < ss) {
                    successClue.splice(i, 0, item);
                    flag = false;
                    break;
                }
                if (successClue[i].startAt === item.startAt) {
                    var oc = new Date(successClue[i].createdAt).getTime();
                    var cc = new Date(item.createdAt).getTime();
                    var spliceIndex = oc < cc ? i + 1 : i;
                    successClue.splice(spliceIndex, 0, item);
                    flag = false;
                    break;
                }
            }
            if (flag) {
                successClue.push(item);
            }
        }
    }
    else {
        var otherClue = currentRecord.otherClues;
        if (!otherClue.length) {
            otherClue.push(item);
        }
        else {
            var flag = true;
            var spliceIndex = null;
            for (var i = 0; i < otherClue.length; i++) {
                if (otherClue[i].clueId === item.clueId) {
                    otherClue.splice(i, 1, item);
                    flag = false;
                    break;
                }
                var ss = new Date(otherClue[i].startAt).getTime();
                var is = new Date(item.startAt).getTime();
                if (is < ss) {
                    spliceIndex = i;
                    flag = false;
                    break;
                }
                if (otherClue[i].startAt === item.startAt) {
                    var os = otherClue[i].status;
                    var is_1 = item.status;
                    flag = false;
                    otherClue[i].isRender = false;
                    if ((os === 'INTENTION' && is_1 === 'INTENTION') ||
                        (os === 'PRE_LOCK' && is_1 === 'PRE_LOCK') ||
                        (os === 'PRE_LOCK' && is_1 === 'INTENTION')) {
                        spliceIndex = i + 1;
                    }
                    if (os === 'INTENTION' && is_1 === 'PRE_LOCK') {
                        spliceIndex = i;
                        break;
                    }
                }
            }
            if (spliceIndex !== null) {
                otherClue.splice(spliceIndex, 0, item);
            }
            if (flag) {
                otherClue.push(item);
            }
        }
    }
    return currentRecord;
}
